// extracted by extract-css-chunks-webpack-plugin
module.exports = {"card":"_2zFN6","cardTitle":"_2c2i4","cardItem":"_2Kbgg","cardItemTitle":"_65ah2","cardItemValue":"AQHf5"};